import { onEscape } from './esc';
import { USE } from '../../../3-store/meeting/usage-state';

// 화상 중계(TURN·SFU) 사용량 창: 서버 /usage(10분마다 새로 센다)를 읽어 이번 달 사용량·비율·상태를 보여 준다. 경고·중지면 버튼에 점. v2에서 옮겼다(docs/2026-10-10-TURN-사용량.md).
// 서버에 CF_ANALYTICS_TOKEN이 없으면 사용량을 못 읽어 상태가 「확인 못 함」이고, 영상 중계는 그대로 된다(v2와 같다).
const $ = (id: string) => document.getElementById(id) as HTMLElement;
const G = (window as any).G;
const USE_ST: Record<string, string> = { ok: '정상', warn: '경고: 80% 넘음', stop: '중지: 95% 넘어 중계·서버 송출을 멈춤', unknown: '확인 못 함' };
function paint() {
  const u = USE.u || {}, st = USE_ST[u.state] ? u.state : 'unknown', ok = typeof u.egressBytes === 'number';
  $('bUse').dataset.st = $('use').dataset.st = st;
  $('useN').textContent = `${ok ? (u.egressBytes / 1e9).toFixed(2) : '—'} GB / ${((u.limitBytes || 1000e9) / 1e9).toLocaleString('en-US')} GB`;
  ($('useBar').firstElementChild as HTMLElement).style.width = (ok ? Math.min(100, u.pct) : 0) + '%';
  $('usePct').textContent = ok ? u.pct.toFixed(2) + '%' : '';
  const gb = (v: unknown) => typeof v === 'number' ? (v / 1e9).toFixed(2) + ' GB' : '—';
  $('useParts').textContent = `TURN 중계 ${gb(u.turnBytes)} · 서버 송출(SFU) ${gb(u.sfuBytes)}`;
  $('useSt').textContent = USE_ST[st];
  $('useAt').textContent = u.updatedAt ? '마지막 확인 ' + new Date(u.updatedAt).toLocaleString('ko-KR', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';
}
const load = () => fetch('/usage').then((r) => (r.ok ? r.json() : null)).catch(() => null).then((u) => { USE.u = u; paint(); });
export const usageState = () => (USE.u && USE.u.state) || 'unknown';
export function openUse() { (document.activeElement as HTMLElement | null)?.blur?.(); USE.open = true; $('use').hidden = false; G.input.locked = true; paint(); load(); }
export function closeUse() { if (!USE.open) return; USE.open = false; $('use').hidden = true; G.input.locked = false; }
export function initUsage() {
  onEscape({ isOpen: () => USE.open, close: closeUse });
  $('bUse').onclick = openUse; $('useX').onclick = closeUse;
  $('use').addEventListener('pointerdown', (e) => { if (e.target === $('use')) closeUse(); });
  load(); setInterval(load, 600000);
}
